export const iconFontAwesomeTransportationCarSide = (
	<i className="fa-solid fa-car-side"></i>
);
